import React, { useState, createContext, useContext } from "react";

const initAuthState = {
  isAuthenticated: sessionStorage.getItem("isAuthenticated") || false,
};

const AuthContext = createContext(initAuthState);
const AuthActionsContext = createContext();

export const useAuthContext = () => useContext(AuthContext);
export const useAuthActionsContext = () => useContext(AuthActionsContext);

export function AuthContextProvider({ children }) {
  const [isAuthenticated, setIsLogged] = useState(
    sessionStorage.getItem("isAuthenticated") || false
  );

  const UpdateLogged = (isLogged) => {
    setIsLogged(isLogged);
    sessionStorage.setItem("isAuthenticated", isLogged);
    if (!isLogged) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userid");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("pageSize");
      sessionStorage.removeItem("currentPage");
      sessionStorage.removeItem("eqGId");
      sessionStorage.removeItem("eqBez");
      sessionStorage.removeItem("copyFunktion");
      sessionStorage.removeItem("isAuthenticated");
      sessionStorage.removeItem("searchQuery");
      sessionStorage.removeItem("isWebsiteAdmin");
      sessionStorage.removeItem("isSuperAdmin");
      sessionStorage.removeItem("isReader");
      sessionStorage.removeItem("organization");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("isManageTicket");
      // sessionStorage.removeItem("APP-LANGUAGE");
      sessionStorage.removeItem("roleId");
      sessionStorage.removeItem("plant");
      sessionStorage.removeItem("organizationID");
      sessionStorage.removeItem("onBoardStoryGuid");
    }
  };

  return (
    // <GlobalContext.Provider value={provider}>{children}</GlobalContext.Provider>
    <AuthContext.Provider value={isAuthenticated}>
      <AuthActionsContext.Provider value={UpdateLogged}>
        {children}
      </AuthActionsContext.Provider>
    </AuthContext.Provider>
  );
}
